import { IStepsTranslation } from 'components/Steps/ISteps';

export const stepsComponent: IStepsTranslation = {
  backButton: 'Back',
  nextButton: 'Next',
  saveButton: 'Save',
};
